import { render, staticRenderFns } from "./NoticeDeleteModal.vue?vue&type=template&id=475e04d6&scoped=true&"
import script from "./NoticeDeleteModal.vue?vue&type=script&lang=js&"
export * from "./NoticeDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDeleteModal.vue?vue&type=style&index=0&id=475e04d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e04d6",
  null
  
)

export default component.exports